import MultiStructureMenu from './MultiStructureMenu';

export default MultiStructureMenu;
